import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Button } from "@/components/ui/button";
import { PropertySelect } from "@/components/agendamentos/PropertySelect";

interface OwnerInfoProps {
  nome: string;
  email: string;
  telefone: string;
  whatsapp: string;
  website: string;
  selectedPropertyId: string;
  properties: Array<{
    id: string;
    title: string;
    link: string;
    price: number;
    ownerId: string;
  }>;
  setNome: (value: string) => void;
  setEmail: (value: string) => void;
  setTelefone: (value: string) => void;
  setWhatsapp: (value: string) => void;
  setWebsite: (value: string) => void;
  setSelectedPropertyId: (value: string) => void;
  onSubmit?: (data: any) => Promise<void>;
}

export function OwnerInfoForm({
  nome,
  email,
  telefone,
  whatsapp,
  website,
  selectedPropertyId,
  properties,
  setNome,
  setEmail,
  setTelefone,
  setWhatsapp,
  setWebsite,
  setSelectedPropertyId,
  onSubmit
}: OwnerInfoProps) {
  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (onSubmit) {
      await onSubmit({
        nome,
        email,
        telefone,
        whatsapp,
        website,
        selectedPropertyId
      });
    }
  };

  return (
    <form onSubmit={handleSubmit} className="space-y-6">
      <h3 className="text-lg font-semibold">Informações do Proprietário</h3>
      
      <div className="space-y-2">
        <Label htmlFor="nome">Nome</Label>
        <Input
          id="nome"
          value={nome}
          onChange={(e) => setNome(e.target.value)}
          placeholder="Nome do proprietário"
        />
      </div>

      <div className="space-y-2">
        <Label htmlFor="email">Email</Label>
        <Input
          id="email"
          type="email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          placeholder="Email do proprietário"
        />
      </div>

      <div className="space-y-2">
        <Label htmlFor="telefone">Telefone</Label>
        <Input
          id="telefone"
          value={telefone}
          onChange={(e) => setTelefone(e.target.value)}
          placeholder="(00) 0000-0000"
        />
      </div>

      <div className="space-y-2">
        <Label htmlFor="whatsapp">WhatsApp</Label>
        <Input
          id="whatsapp"
          value={whatsapp}
          onChange={(e) => setWhatsapp(e.target.value)}
          placeholder="(00) 00000-0000"
        />
      </div>

      <div className="space-y-2">
        <Label htmlFor="website">Website</Label>
        <Input
          id="website"
          type="url"
          value={website}
          onChange={(e) => setWebsite(e.target.value)}
          placeholder="https://www.exemplo.com"
        />
      </div>

      <div className="space-y-2">
        <Label>Imóvel Existente</Label>
        <PropertySelect
          properties={properties}
          ownerId=""
          value={selectedPropertyId}
          onChange={setSelectedPropertyId}
        />
      </div>

      {onSubmit && (
        <Button type="submit" className="w-full">
          Salvar
        </Button>
      )}
    </form>
  );
}